import React from 'react';
import Select from 'react-select';
import {
  StyledCheckIcon,
  Options_LI,
} from '../CommonStyledElement/CommonStyledElement';

const CustomOption = ({ innerProps, label, isSelected }) => (
  <Options_LI
    {...innerProps}
    key={label}
    style={{ color: isSelected ? '#353cf7' : '#707070' }}
  >
    <StyledCheckIcon active={isSelected ? 'true' : 'false'} />
    {label}
  </Options_LI>
);

const CustomDropdown = (props) => {
  const {
    id,
    isSearchable,
    isClearable,
    controlHeight,
    height,
    placeholderMarginTop,
    placeholderColor,
    maxMenuHeight,
    defaultValue,
    placeholder,
    options,
    menuWidth,
    containerWidth,
    onChange,
    className,
    name,
    value,
    onBlur,
    //
    field,
    border,
    menuIsOpen,
    menuPlacement,
    controlStyles,
    menuStyles,
    components,
    placeholderStyles,
    customDropdownIndicator,
    ...rest
  } = props;

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      //   '&:hover': {
      //     backgroundColor: '#dcefff',
      //     borderRadius: '5px',
      //     cursor: 'pointer',
      //   },
      backgroundColor: state.isFocused
        ? '#dcefff'
        : state.isSelected
        ? '#51a5ec'
        : 'white',
      borderRadius: state.isSelected ? '5px' : '',
      color: '#021D33',
      padding: '9px',
    }),
    control: (provided) => ({
      ...provided,
      border: border || 'none',
      textAlign: 'left',
      fontSize: '18px',
      borderRadius: rest.controlBorderRadius || '32px',
      boxShadow: 'white',
      cursor: 'pointer',
      minHeight: controlHeight,
      height: height || provided.height,
      ...controlStyles,
    }),
    container: (provided) => ({
      ...provided,
      width: containerWidth,
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '10px',
      textAlign: 'left',
      fontSize: '16px',
      width: menuWidth || provided.width,
      marginTop: '12px',
      boxShadow:
        '0 0 0 1px hsl(0deg 0% 0% / 0%), 0 4px 11px hsl(0deg 0% 0% / 10%)',
      zIndex: 10,
      ...menuStyles,
    }),
    singleValue: (provided) => ({
      ...provided,
      marginLeft: '10px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '10px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: placeholderColor,
      marginLeft: '10px',
      marginTop: placeholderMarginTop || provided.marginTop,
      ...placeholderStyles,
    }),
    input: (provided) => ({
      ...provided,
      marginLeft: '10px',
    }),
  };

  const componentsConfig = {
    Option: CustomOption,
    IndicatorSeparator: null,
    ...components,
  };

  if (customDropdownIndicator) {
    componentsConfig.DropdownIndicator = () => customDropdownIndicator;
  }
  return (
    <Select
      id={id}
      name={name}
      className={className}
      instanceId={id}
      maxMenuHeight={maxMenuHeight}
      defaultValue={defaultValue ? defaultValue : null}
      placeholder={placeholder}
      isSearchable={isSearchable}
      isClearable={isClearable}
      options={options}
      styles={customStyles}
      components={componentsConfig}
      onFocus={rest.onFocus}
      onChange={onChange}
      value={value}
      onBlur={onBlur}
      menuPlacement={menuPlacement || 'bottom'}
      menuIsOpen={menuIsOpen}
      {...field}
      {...rest}
    />
  );
};

export default CustomDropdown;
